import api from '@/apis/dvc/dVCFileM01API.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('dVCFileM01', api);

const state = {
  ...crud.state,
  _config: {
    table: 'dvc_file_m01',
    field: {
      key: 'dvc_file_m01_id',
      //   code: 'file_code'
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
